import {Button, Col, notification, Row, Spin, Tooltip} from 'antd';
import React, {useCallback, useRef, useState} from 'react';
import {Link, useLocation} from 'react-router-dom';
import styled from 'styled-components';
import axios from 'axios';
import Dragger from 'antd/lib/upload/Dragger';
import {useNavigate} from 'react-router-dom';
import {CheckCircleFilled, EyeFilled, FolderOpenFilled, LoadingOutlined, MinusCircleOutlined, WarningFilled} from '@ant-design/icons';
import update from 'immutability-helper';
import {DndProvider, useDrag, useDrop} from 'react-dnd';
import {HTML5Backend} from 'react-dnd-html5-backend';
import {CloudUploadOutlined, FolderFilled} from '@ant-design/icons';
import { StringParam, useQueryParam } from 'use-query-params';
import { DOCUMENT_TYPE, OPTION_NGOAITRU, OPTION_NOITRU } from '../utils/type';
import PreviewFile from '../Component/PreviewFile';
import PreviewPDFBase64 from '../Component/ViewFile';
import { FiSend } from 'react-icons/fi';
import { MdCancel } from 'react-icons/md';
import { IoDocument } from 'react-icons/io5';
const type = 'DragableUploadList';


const DragableUploadListItem = ({originNode, moveRow, file, fileList}) => {
    const ref = useRef(null);
    const index = fileList.indexOf(file);
    const [{isOver, dropClassName}, drop] = useDrop({
        accept: type,
        collect: monitor => {
            const {index: dragIndex} = monitor.getItem() || {};
            if (dragIndex === index) {
                return {};
            }
            return {
                isOver: monitor.isOver(),
                dropClassName: dragIndex < index ? ' drop-over-downward' : ' drop-over-upward',
            };
        },
        drop: item => {
            moveRow(item.index, index);
        },
    });
    const [, drag] = useDrag({
        type,
        item: {
            index,
        },
        collect: monitor => ({
            isDragging: monitor.isDragging(),
        }),
    });
    drop(drag(ref));
    const errorNode = <Tooltip title="Upload Error">{originNode.props.children}</Tooltip>;
    return (
        <div
            ref={ref}
            className={`ant-upload-draggable-list-item ${isOver ? dropClassName : ''}`}
            style={{
                cursor: 'move',
            }}>
            {file.status === 'error' ? errorNode : originNode}
        </div>
    );
};

const UploadSuccess = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const {data, files} = location.state || {};
    const [dataResponse, setDataResponse] = useState(data);
    const [fileUploaded, setFileUploaded] = useState(files);
    const {missing_docs , data : dataInRes} = dataResponse || {};
    // const missing_docs =[];
    const [claimType] = useQueryParam('type', StringParam);
    const [isVisible, setIsVisible] = useState(false);
    const [previewFile, setPreviewFile] = useState({});

    const [isViewFile, setIsViewFile] = useState(false);

    const claimName = claimType === 'noi_tru' ? 'Nội trú' : 'Ngoại trú';

    const [listFile, setListFile] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingSend, setLoadingSend] = useState(false);
    const antIcon = (
        <LoadingOutlined
            style={{
                fontSize: 24,
                color: 'white',
            }}
            spin
        />
    );
    const handleUpload = () => {
        const formData = new FormData();
        setLoading(true);
        listFile.map(e => {
            formData.append('files', e.originFileObj);
        });
        files.map(e => {
            formData.append('files', e.originFileObj);
        });
        formData.append('claim_type', claimType);

        const options = {
            method: 'POST',
            params : {
                check_missing: true
            },
            data: formData,
            // url: `https://dev.docbase.ai/api/v1/folders`,
            url: `https://tpa.docbase.ai/api/v1/documents/classify`
        };
        axios(options)
            .then(res => {
                setLoading(false);
                setDataResponse(res.data);
                setFileUploaded(fileUploaded => [...fileUploaded, ...listFile]);

            })
            .catch(error => {
                setLoading(false);
                notification.error({
                    message: error.message,
                });
            });
    };

    const moveRow = useCallback(
        (dragIndex, hoverIndex) => {
            const dragRow = listFile[dragIndex];
            setListFile(
                update(listFile, {
                    $splice: [
                        [dragIndex, 1],
                        [hoverIndex, 0, dragRow],
                    ],
                }),
            );
        },
        [listFile],
    );
    const onChange = e => {
        setListFile(e.fileList);
    };

    const countSubmission = dataResponse?.data?.label_id.filter((doc) => doc.label).reduce(
        (acc,curr) => {
            const key = curr.label;
            acc[key] = acc[key] ? acc[key] + 1 : 1;
            return acc;
        },
        {}
    )
    const type = claimType === 'noi_tru' ? OPTION_NOITRU : OPTION_NGOAITRU;
    const options = claimType === 'noi_tru'
        ? Object.keys(OPTION_NOITRU)
        : Object.keys(OPTION_NGOAITRU);
    const optionsMissing = options.filter(
        option => !Object.keys(countSubmission).includes(option)
    )
    const reqSubmission = {
        require: missing_docs,
        options: optionsMissing.map(option => {
            return type[option]?.label;
        })
    }

    const handlePreview = (file) => {
        setPreviewFile(file);
        setIsVisible(true);
    };

    const handleUploadToDocbase = () => {
        const formData = new FormData();
        setLoadingSend(true);
        fileUploaded.map(e => {
            formData.append('files', e.originFileObj);
        });
        formData.append('external_id' , randomId(16));
        formData.append('claim_number' , randomId(16));

        const options = {
            method: 'POST',
            params : {
                type: 'file',
            },

            auth: {
                username:'b1ee27b4-7231-4a60-926f-51e70b601214',
            },
            data: formData,
            url: `https://tpa.docbase.ai/api/v1/integrations/folders/100/submissions`
        };
        axios(options)
            .then(res => {
                setLoadingSend(false);
                navigate(`/success`, {
                    state: {
                        data: res.data,
                        files: listFile,
                    }
                    ,
                });
            })
            .catch(error => {
                setLoadingSend(false);
                notification.error({
                    message: error.message,
                });
        });
    }


    return (
        <>
            <UploadSuccessWrapper>
                <ResponsiveRow>
                    <LeftColumn xs={24} md={14}>
                        <LeftContainer>
                            <Text>Bổ sung hồ sơ</Text>
                            <DndProvider backend={HTML5Backend}>
                                <Dragger
                                    name="file"
                                    accept=".png,.jpg,.jpeg,.pdf"
                                    multiple
                                    beforeUpload={() => {
                                        return false;
                                    }}
                                    fileList={listFile}
                                    listType="picture"
                                    onChange={onChange}
                                    itemRender={(originNode, file, currFileList) => (
                                        <DragableUploadListItem
                                            originNode={originNode}
                                            file={file}
                                            fileList={currFileList}
                                            moveRow={moveRow}
                                        />
                                    )}>
                                    <ChooseFile>
                                        <IconUpload>
                                            <CloudUploadOutlined style={{ fontSize: '40px', color: '#ec1c2b' }} />
                                        </IconUpload>
                                        <TextUploadContainer>Chọn file</TextUploadContainer>
                                        <TitleUploadContainer>
                                            Kéo và thả file vào đây hoặc{' '}
                                            <button
                                                style={{
                                                    border: 'none',
                                                    padding: '0px',
                                                    background: '#f4f6f8',
                                                    color: '#ec1c2b',
                                                    textDecoration: 'underLine',
                                                    cursor: 'pointer',
                                                }}>
                                                Chọn tệp
                                            </button>{' '}
                                            từ thiết bị của bạn
                                        </TitleUploadContainer>
                                        <TitleUploadContainer>
                                            Định dạng hỗ trợ: .png, .jpg, .jpeg, .pdf
                                        </TitleUploadContainer>
                                    </ChooseFile>
                                </Dragger>
                            </DndProvider>
                            <WrapBtn>
                                {listFile?.length === 0
                                ?
                                <Tooltip title="Vui lòng chọn file">
                                    <span>
                                        <Button
                                            disabled={listFile?.length === 0 ? true : false}
                                            className="btnBS"
                                            type="primary"
                                            onClick={handleUpload}
                                            >
                                            {loading ? <Spin indicator={antIcon} /> : 'Tải lên'}
                                        </Button>
                                    </span>
                                </Tooltip >
                                :<Button
                                    className="btnBS"
                                    type="primary"
                                    onClick={handleUpload}
                                    >
                                    {loading ? <Spin indicator={antIcon} /> : 'Tải lên'}
                                </Button>
                                }
                            </WrapBtn>
                        </LeftContainer>

                        <FileUploaded>
                            <FileTitle>
                                <FileTitleAhead>
                                    <FolderOpenFilled style={{ fontSize: '24px', color: '#ec1c2b' }} />
                                    Danh sách file đã tải lên
                                </FileTitleAhead>
                                <ViewBtnWrapper onClick={() => setIsViewFile(true)}>
                                    Xem file đã xử lý
                                </ViewBtnWrapper>
                            </FileTitle>
                            <FileList>
                                {fileUploaded && fileUploaded.map((file, index) => (
                                    <FileItem key={index}>
                                        <FileItemAhead>
                                            <FileItemIcon>
                                                <IoDocument style={{ fontSize: '28px', color: '#28ab5a' }} />
                                            </FileItemIcon>
                                            <FileItemName>
                                                <p>
                                                    {file.name}
                                                </p>
                                                <span>{(file.size/(1024*1024)).toFixed(2) } MB </span>
                                            </FileItemName>
                                        </FileItemAhead>
                                        <FileItemView onClick={() => handlePreview(file)} >
                                            Xem
                                        </FileItemView>
                                    </FileItem>
                                 ))}
                            </FileList>
                        </FileUploaded>
                    </LeftColumn>

                    <RightColumn xs={24} md={10}>
                        <WarningField isWarning={missing_docs.length > 0}>
                            {missing_docs.length > 0
                            ? <WarningFilled style={{ fontSize: '24px', color: '#ea580c' }}/>
                            : <CheckCircleFilled style={{ fontSize: '24px', color: '#16a34a' }} />
                            }
                           <p>{missing_docs.length > 0 ? 'Hồ sơ còn thiếu giấy tờ' : 'Hồ sơ đã đầy đủ'}</p>
                        </WarningField>
                        <RightContainer>
                            {missing_docs.length > 0 &&
                                <MissingWrapper>
                                    <Text className='require'>Yêu cầu bổ sung giấy tờ - {claimName} </Text>
                                    <FileRequireList>
                                        {reqSubmission.require.map((doc, index) => (
                                            <FileRequireItem key={index}>
                                                <FileItemIcon>
                                                    <MdCancel style={{ fontSize: '28px', color: '#ec1c2b' }} />
                                                </FileItemIcon>
                                                <FileItemName>
                                                    <p>
                                                        {doc}
                                                    </p>
                                                </FileItemName>
                                            </FileRequireItem>
                                        ))}
                                        {reqSubmission.options.map((doc, index) => (
                                            <FileRequireItem key={index} isOption={true}>
                                                <FileItemIcon>
                                                    <MinusCircleOutlined style={{ fontSize: '24px', color: '#9ca3af' }} />
                                                </FileItemIcon>
                                                <FileItemName>
                                                    <p>
                                                        {doc}
                                                    </p>
                                                </FileItemName>
                                            </FileRequireItem>
                                        ))}
                                    </FileRequireList>
                                </MissingWrapper>
                            }
                            <Text className='complete'>Giấy tờ đã có</Text>
                            <FileList>
                                {Object.entries(countSubmission).map(([key, value]) => {
                                    return (
                                        <FileItem key={key}>
                                            <FileItemAhead>
                                                <FileItemIcon>
                                                    <IoDocument style={{ fontSize: '28px', color: '#16a34a' }} />
                                                </FileItemIcon>
                                                <FileItemName>
                                                    <p>
                                                        {DOCUMENT_TYPE[key].label}
                                                    </p>
                                                </FileItemName>
                                            </FileItemAhead>
                                            <SL>
                                                <span>{value}</span> Trang
                                            </SL>
                                        </FileItem>
                                    )
                                    })
                                }
                            </FileList>
                        </RightContainer>
                    </RightColumn>

                    <ButtonWrapper>
                        <Button className="btnBack" onClick={() => navigate(-1)}>
                            ← Quay lại
                        </Button>
                        {missing_docs.length > 0
                        ?
                        <Tooltip title="Vui lòng bổ sung giấy tờ còn thiếu">
                            <span>
                                <Button
                                    className="btnBS"
                                    onClick={handleUploadToDocbase}
                                    disabled={missing_docs.length > 0}
                                    >
                                    {loadingSend ? <Spin indicator={antIcon} style={{marginRight: 8}}/> : <FiSend style={{marginRight: 8}}/> }
                                    Gửi hồ sơ
                                </Button>
                            </span>
                        </Tooltip>
                        : <Button
                            className="btnBS"
                            onClick={handleUploadToDocbase}
                            >
                            {loadingSend ? <Spin indicator={antIcon} /> : <FiSend style={{marginRight: 8}}/> }
                            Gửi hồ sơ
                        </Button>
                        }
                    </ButtonWrapper>
                </ResponsiveRow>
            </UploadSuccessWrapper>

            <PreviewFile
                file={previewFile}
                isVisible={isVisible}
                setIsVisible={setIsVisible}
            />
            <PreviewPDFBase64
                base64Data={dataInRes?.pdf}
                data={dataInRes?.label_id}
                fileName='Document.pdf'
                isVisible={isViewFile}
                setIsVisible={setIsViewFile}
            />
        </>
    );
};

export default UploadSuccess;

const randomId = (length = 16) => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let result = '';

    for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return result;
};

const UploadSuccessWrapper = styled.div`
    min-height: 100vh;
    background: #f9fafb;
    padding-bottom: 40px;

    @media screen and (max-width: 739px) {
        padding-bottom: 20px;
    }
`;

const ResponsiveRow = styled(Row)`
    @media screen and (max-width: 739px) {
        flex-direction: column;
    }
`;

const LeftColumn = styled(Col)`
    @media screen and (max-width: 739px) {
        width: 100% !important;
        max-width: 100% !important;
    }
`;

const RightColumn = styled(Col)`
    @media screen and (max-width: 739px) {
        width: 100% !important;
        max-width: 100% !important;
    }
`;

const RightContainer = styled.div`
    width: 420px;
    padding: 20px;
    margin: 20px auto 0px 0px;
    display: flex;
    flex-direction: column;
    justify-self: flex-start;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    background: #ffffff;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);

    @media screen and (max-width: 739px) {
        width: calc(100% - 32px);
        margin: 16px 16px 0px 16px;
    }
`;

const WarningField = styled.div`
    width: 420px;
    height: 60px;
    margin: 40px auto 0px 0px;
    padding-left: 20px;
    display: flex;
    flex-direction: row;
    justify-self: flex-start;
    align-items: center;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    background: ${props => props.isWarning ? '#fff7ed' : '#f0fdf4'};
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    gap: 12px;
    
    p {
        margin: 0px;
        font-weight: 600;
        font-size: 16px;
        line-height: 140%;
    }

    @media screen and (max-width: 739px) {
        width: calc(100% - 32px);
        margin: 24px 16px 0px 16px;
        height: auto;
        min-height: 60px;
        padding: 12px 16px;
        
        p {
            font-size: 14px;
        }
    }
`;

const MissingWrapper = styled.div`
    margin-bottom: 30px;

    @media screen and (max-width: 739px) {
        margin-bottom: 24px;
    }
`;

const LeftContainer = styled.div`
    width: 720px;
    margin: 40px 30px 0px auto;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-self: flex-end;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    background: #ffffff;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);

    .ant-upload-drag {
        width: 680px !important;
    }
    .ant-upload-list{
        width: 680px !important;
    }
   
    @media screen and (max-width: 739px) {
        width: calc(100% - 32px);
        margin: 24px 16px 0px 16px;
        padding: 16px;
        
        .ant-upload-drag {
            width: 100% !important;
        }
        .ant-upload-list {
            width: 100% !important;
        }
    }
`;

const FileUploaded = styled.div`
    margin: 20px 30px 0px auto;    
    padding: 20px;
    width: 720px;
    display: flex;
    justify-self: flex-end;
    flex-direction: column;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    background: #ffffff;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    
    span {
        display: block;
        font-size: 14px;
        line-height: 20px;
        color: #374151;
    }

    @media screen and (max-width: 739px) {
        width: calc(100% - 32px);
        margin: 16px 16px 0px 16px;
        padding: 16px;
    }
`;

const FileList = styled.div`
    width: 100%;
`;

const FileRequireList = styled.div`
    width: 100%;
`;

const FileItem = styled.div`
    width: 100%;
    height: 60px;
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #bbf7d0;
    border-radius: 8px;
    background: #f0fdf4;
    padding: 8px;
    gap: 12px;
    transition: all 0.2s ease-in-out;
    
    :hover {
        scale: 1.02;
    }

    @media screen and (max-width: 739px) {
        height: auto;
        min-height: 60px;
        gap: 8px;
    }
`;

const FileItemAhead = styled.div`
    display: flex;
    flex-direction: row;
    gap: 12px;
    align-items: center;
    flex: 1;
    min-width: 0;

    @media screen and (max-width: 739px) {
        gap: 8px;
    }
`;

const FileRequireItem = styled.div`
    width: 100%;
    height: 60px;
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background: ${p => p.isOption ? '#f9fafb' : '#fef2f2'};
    padding: 8px;
    gap: 12px;
    transition: all 0.2s ease-in-out;
    
    :hover {
        scale: 1.02;
    }

    @media screen and (max-width: 739px) {
        height: auto;
        min-height: 60px;
        gap: 8px;
    }
`;

const FileItemIcon = styled.div`
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;

    @media screen and (max-width: 739px) {
        width: 32px;
        height: 32px;
        
        svg {
            font-size: 24px !important;
        }
    }
`;

const FileItemName = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
    min-width: 0;
    
    p {
        margin: 0px;
        font-weight: 600;
        font-size: 14px;
        line-height: 140%;
        color: rgba(0, 0, 0, 0.85);
        word-break: break-word;
    }
    
    span {
        margin: 0px;
        font-weight: 400;
        font-size: 12px;
        line-height: 140%;
        color: rgba(0, 0, 0, 0.65);
    }

    @media screen and (max-width: 739px) {
        p {
            font-size: 13px;
        }
        
        span {
            font-size: 11px;
        }
    }
`;

const FileItemView = styled.div`
    color: #28ab5a;
    padding: 4px 8px;
    border-radius: 4px;
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    cursor: pointer;
    white-space: nowrap;
    flex-shrink: 0;
    
    :hover {
        background-color: #dcfce7;
        scale: 1.1;
    }
    
    transition: all 0.3s ease-in-out;

    @media screen and (max-width: 739px) {
        font-size: 12px;
        padding: 4px 6px;
    }
`;

const SL = styled.div`
    background-color: #dcfce7;
    color: #28ab5a;
    padding: 4px 8px;
    border-radius: 4px;
    font-weight: 600;
    font-size: 12px;
    line-height: 140%;
    display: flex;
    white-space: nowrap;
    flex-shrink: 0;
    
    span {
        margin-right: 4px;
    }

    @media screen and (max-width: 739px) {
        font-size: 11px;
        padding: 4px 6px;
    }
`;

const IconUpload = styled.div`
    border: none;
    border-radius: 50%;
    width: 64px;
    min-height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fee2e2;
    margin-bottom: 16px;

    @media screen and (max-width: 739px) {
        width: 56px;
        min-height: 56px;
        margin-bottom: 12px;
        
        svg {
            font-size: 32px !important;
        }
    }
`;

const Text = styled.h4`
    height: 39px;
    font-weight: 600;
    font-size: 19px;
    margin-bottom: 0px;
    color: rgba(0, 0, 0, 0.85);

    @media screen and (max-width: 739px) {
        font-size: 17px;
        height: auto;
    }
`;

const FileTitle = styled.div`
    height: 39px;
    font-weight: 600;
    font-size: 19px;
    line-height: 140%;
    color: rgba(0, 0, 0, 0.85);
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    gap: 12px;

    @media screen and (max-width: 739px) {
        font-size: 16px;
        height: auto;
        min-height: 39px;
        gap: 8px;
        flex-wrap: wrap;
    }
`;

const FileTitleAhead = styled.div`
    display: flex;
    flex-direction: row;
    gap: 12px;
    align-items: center;

    @media screen and (max-width: 739px) {
        gap: 8px;
        font-size: 16px;
        
        svg {
            font-size: 20px !important;
        }
    }
`;

const ViewBtnWrapper = styled.div`
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
    border-radius: 12px;
    padding: 4px 8px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    white-space: nowrap;
    
    :hover {
        color: #28ab5a;
        background-color: #f0fdf4;
        border: 1px solid #28ab5a;
        scale: 1.05;
    }

    @media screen and (max-width: 739px) {
        font-size: 12px;
        padding: 4px 6px;
    }
`;

const TextUploadContainer = styled.h4`
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    color: #212b36;
    margin: 0px;
    
    @media screen and (max-width: 739px) {
        text-align: center;
        font-size: 18px;
    }
`;

const TitleUploadContainer = styled.span`
    font-weight: 400;
    font-size: 13px;
    line-height: 22px;
    color: #637381;
    
    @media screen and (max-width: 739px) {
        font-size: 12px;
        text-align: center;
    }
`;

const ChooseFile = styled.div`
    padding: 0px;
    gap: 8px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 60px;
    margin-right: 28px;
    
    @media screen and (max-width: 739px) {
        margin: 0px;
        display: flex;
        flex-direction: column;
        width: auto;
        height: auto;
        padding: 20px 0;
    }
`;

const WrapBtn = styled.div`
    display: flex;
    margin-top: 26px;
    width: 100%;
    justify-content: flex-end;
    
    .btnBS {
        padding: 8px 18px;
        gap: 8px;
        border: #ec1c2a;
        height: 48px;
        background: #ec1c2a;
        border-radius: 8px;
        color: #fff;
    }
    
    @media screen and (max-width: 739px) {
        justify-content: center;
        margin-top: 20px;
        
        .btnBS {
            width: 100%;
        }
    }
`;

const ButtonWrapper = styled.div`
    display: flex;
    margin-top: 40px;
    width: 1175px;
    margin-left: calc(58% - 750px);
    align-items: center;
    justify-content: space-between;

    .btnBS {
        padding: 8px 18px;
        gap: 12px;
        border: #ec1c2a;
        height: 48px;
        background: #9ca3af;
        border-radius: 8px;
        color: #fff;
        
        :hover {
            background-color: #ec1c2a;
        }
    }
    
    .btnBack {
        height: 48px;
        padding: 8px 18px;
        border-radius: 8px;
    }
    
    .ant-btn:disabled,
    .ant-btn[disabled] {
        color: #fff !important;
        background-color: #9ca3af !important;
        border-color: #9ca3af !important;
    }

    @media screen and (max-width: 739px) {
        width: calc(100% - 32px);
        margin: 24px 16px 0px 16px;
        flex-direction: row;
        gap: 12px;
        
        .btnBS,
        .btnBack {
            flex: 1;
            height: 44px;
            font-size: 14px;
            padding: 8px 12px;
        }
    }
`;